/**
 * HomeGroupWA Finance Application landing Page JS Include
 *
 * @author Strange Animals <developer@strangeanimals.com.au>
 */

window.FinanceApplicationLandingPageObject = function(opts) {
    var financeapplicationlandingpage_obj = $.extend(new window.PageObject({}), {
        //page interactivity
        setup: function() {
            var self = this;

            self.initIsRenting();
            self.initPartnerToggler();
        },

        initIsRenting: function() {
            var $howMuchRentField = document.querySelector('#HowMuchRent');
            // Initially set HowMuchRent field to hidden
            $howMuchRentField.style.display = 'none';

            $('#TotemForm_FinanceApplicationLandingPageForm_IsRenting').on('change', function() {
                $('#HowMuchRent').fadeToggle();
            });
        },

        initPartnerToggler: function() {
            var $partnerCheckbox = $('.has-partner-switch [type="checkbox"]');
            var $partnerSection = $('.partner-section');
            var $container = $('html,body');

            $partnerCheckbox.on('click', function() {
                $partnerSection.fadeToggle();
                $container.animate(
                    {
                        scrollTop: $partnerSection.offset().top - 200,
                        scrollLeft: 0
                    },
                    500
                );
            });
        },

        //event handlers...
        onInit: function() {},
        onReady: function() {
            this.setup();
        },
        onResize: function() {},
        onLoad: function() {}
    });

    if (opts) {
        return $.extend(financeapplicationlandingpage_obj, opts);
    } else {
        return financeapplicationlandingpage_obj;
    }
};
